// eslint-disable-next-line no-restricted-imports
import type { EmotionCache } from '@emotion/cache';
// eslint-disable-next-line no-restricted-imports
import createCache from '@emotion/cache';
// eslint-disable-next-line no-restricted-imports
import { CacheProvider as EmotionCacheProvider } from '@emotion/react';
import {
  SHADOW_APP_ID,
  SHADOW_APP_PORTAL_ID,
  SHADOW_HOST_ID,
} from '@iheartjane/reefer';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import root from 'react-shadow';

import '@iheartjane/reefer/styles/index.css';
import './shadowStyles.css';

const ShadowRootDiv = root['div'];

export const ShadowRoot = ({ children }: PropsWithChildren) => {
  const [emotionCache, setEmotionCache] = useState<EmotionCache | null>(null);

  function setEmotionStyles(ref: HTMLDivElement) {
    if (ref && !emotionCache) {
      const createdEmotionWithRef = createCache({
        key: 'css',
        container: ref,
      });
      setEmotionCache(createdEmotionWithRef);
    }
  }

  return (
    <ShadowRootDiv id={SHADOW_HOST_ID}>
      <style>{SHADOW_STYLE}</style>
      <div ref={setEmotionStyles} id="shadow-emotion">
        {emotionCache && (
          <EmotionCacheProvider value={emotionCache}>
            <div
              /**
               * Modals and popovers go into this element. For accessibility reasons
               * the modals should not "portal" into the app itself but into
               * a sibling according to react-modal:
               * @see https://reactcommunity.org/react-modal/#using-a-custom-parent-node
               */
              id={SHADOW_APP_PORTAL_ID}
            />
            <div id={SHADOW_APP_ID}>{children}</div>
          </EmotionCacheProvider>
        )}
      </div>
    </ShadowRootDiv>
  );
};
